var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionTemplate',{staticClass:"gallery-section",attrs:{"title":"Galeria","title-align":"left","no-container":_vm.noContainer}},[_c('GridWidget',{attrs:{"cols":_vm.cols}},_vm._l((_vm.items),function(ref,i){
var src = ref.src;
return _c('picture',{key:i,on:{"click":function($event){return _vm.showGallery(i)}}},[_c('img',{attrs:{"src":src + '?resize=1&w=400'}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }